<template>
  <button class="sp_audio_input_btn" :class="{ recording: isRecording }" @click="toggleVoiceRecognition">
    <SoundBarsIcon :isRecording="isRecording" recordingColor="#dc2626" />
  </button>
</template>

<script>
import SoundBarsIcon from "../SoundBarsIcon/index.vue";

export default {
  name: "VoiceRecordButton",
  components: {
    SoundBarsIcon,
  },
  props: {
    isRecording: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    toggleVoiceRecognition() {
      this.$emit("toggle");
    },
  },
};
</script>

<style lang="scss" scoped>
.sp_audio_input_btn {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border: none;
  background: transparent;
  color: #6b7280;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  padding: 0;
  border-radius: 8px;

  &:hover {
    background: #f3f4f6;
    color: var(--sp-chat-primary);
  }

  &.recording {
    background: #fee2e2 !important;
    color: #dc2626;

    &:hover {
      background: #fecaca !important;
      color: #b91c1c;
    }
  }
}
</style>
